import C from '../../../constants';

export const tenant = (state = {}, action) => {
    switch (action.type) {
        case C.SET_TENANT:
            return Object.assign({}, state, action.payload);

        case C.SET_TENANT_ROOMMATE_GROUP:
            return {
                ...state,
                roommate_group: action.payload
            };

        case C.SET_TENANT_INVITATIONS:
            return {
                ...state,
                invitations: action.payload
            };

        case C.SET_TENANT_APPLICATION:
            return {
                ...state,
                application: action.payload
            };

        case C.SET_IDMA_STATUS:
            return {
                ...state,
                idmaStatus: action.payload
            };

        case C.SET_TENANT_BILLING_STATUS:
            return {
                ...state,
                billing: {
                    ...state.billing,
                    status: action.payload
                }
            };

        case C.SET_TENANT_BILLING_METHOD:
            return {
                ...state,
                billing: {
                    ...state.billing,
                    payment_method: action.payload
                }
            };

        case C.SET_TENANT_BILLING_HISTORY:
            return {
                ...state,
                billing: {
                    ...state.billing,
                    history: action.payload
                }
            };

        case C.SET_TENANT_STRIPE_DETAILS:
            return {
                ...state,
                billing: {
                    ...state.billing,
                    stripe_details: action.payload
                }
            };

        case C.SET_TENANT_LISTING_PREFERENCES:
            return {
                ...state,
                listing_preferences: action.payload

            };

        case C.SET_TENANT_LISTING_PREF_RENT:
            return {
                ...state,
                listing_preferences: {
                    ...state.listing_preferences,
                    min_rent: action.payload.min_rent,
                    max_rent: action.payload.max_rent
                }
            };

        case C.SET_TENANT_LISTING_PREF_BATH:
            return {
                ...state,
                listing_preferences: {
                    ...state.listing_preferences,
                    min_bathrooms: action.payload.min_bathrooms,
                    max_bathrooms: action.payload.max_bathrooms
                }
            };

        case C.SET_TENANT_LISTING_PREF_BED:
            return {
                ...state,
                listing_preferences: {
                    ...state.listing_preferences,
                    min_bedrooms: action.payload.min_bedrooms,
                    max_bedrooms: action.payload.max_bedrooms
                }
            };

        case C.SET_TENANT_MIN_LEASE_START:
            return {
                ...state,
                listing_preferences: {
                    ...state.listing_preferences,
                    min_lease_start_month: action.payload
                }
            };

        case C.SET_TENANT_MAX_LEASE_START:
            return {
                ...state,
                listing_preferences: {
                    ...state.listing_preferences,
                    max_lease_start_month: action.payload
                }
            };

        case C.SET_TENANT_RECOMMENDED_LISTINGS:
            return {
                ...state,
                recommended_listings: action.payload
            };

        case C.SET_TENANT_RENTAL_HISTORY:
            return {
                application: {
                    ...state.application,
                    rental_history_rentals: action.payload
                }
            };

        case C.SET_TENANT_EMPLOYMENT_HISTORY:
            return {
                application: {
                    ...state.application,
                    employment_history_positions: action.payload
                }
            };

        case C.ADD_INTEREST_LIST:
            return {
                ...state,
                interest_list: [
                    ...state.interest_list,
                    action.payload
                ]
            };

        case C.REMOVE_INTEREST_LIST:
            const index = state.interest_list.indexOf(state.interest_list.find(function (item) {
                return item.id === action.payload.id;
            }));
            return {
                ...state,
                interest_list: [
                    ...state.interest_list.slice(0, index),
                    ...state.interest_list.slice(index + 1)
                ]
            };

        case C.SET_INTEREST_LIST:
            return {
                ...state,
                interest_list: action.payload
            };

        default:
            return state;
    }

};


// WEBPACK FOOTER //
// ./src/containers/tenant/reducers/tenantReducer.js